module.exports = __webpack_public_path__ + "static/speedvapor-78811f1b439d9fa5cdaa637248753f4c.jpg";